import { render, staticRenderFns } from "./AddCustomer.vue?vue&type=template&id=4e5c8e2b&scoped=true"
import script from "./AddCustomer.vue?vue&type=script&lang=js"
export * from "./AddCustomer.vue?vue&type=script&lang=js"
import style0 from "./AddCustomer.vue?vue&type=style&index=0&id=4e5c8e2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5c8e2b",
  null
  
)

export default component.exports